import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconAccelerationMiddleProps } from './IconAccelerationMiddle.types'
import * as Styled from './styles/IconAccelerationMiddle.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAccelerationMiddle: FC<IconAccelerationMiddleProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAccelerationMiddleProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconAccelerationMiddleProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M21.477 12.04c0 5.245-4.254 9.5-9.5 9.5-5.247 0-9.5-4.255-9.5-9.5 0-5.25 4.253-9.5 9.5-9.5h9.5Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M12.957 12.922a1.273 1.273 0 0 1-1.82-1.777 1.251 1.251 0 0 1 1.765-.051l.016.015 3.668-3.671M5.52 10.5c.605-2.34 2.664-4.063 5.105-4.063a5.14 5.14 0 0 1 2.367.575l1.156-1.16a6.723 6.723 0 0 0-8.523 4.222 5.32 5.32 0 0 0-.125.426'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconAccelerationMiddle
